module.exports = __webpack_public_path__ + "img/zixun6.62d646c8.png";